import { render, staticRenderFns } from "./NewBook_phone.vue?vue&type=template&id=d4e3b448&scoped=true"
import script from "./NewBook_phone.vue?vue&type=script&lang=js"
export * from "./NewBook_phone.vue?vue&type=script&lang=js"
import style0 from "./NewBook_phone.vue?vue&type=style&index=0&id=d4e3b448&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e3b448",
  null
  
)

export default component.exports